import { render, staticRenderFns } from "./bFeedbackLabel.vue?vue&type=template&id=6813e905&scoped=true"
import script from "./bFeedbackLabel.vue?vue&type=script&lang=js"
export * from "./bFeedbackLabel.vue?vue&type=script&lang=js"
import style0 from "./bFeedbackLabel.vue?vue&type=style&index=0&id=6813e905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813e905",
  null
  
)

export default component.exports